import { render } from "./MailboxTwoIcon.vue?vue&type=template&id=299f0cc2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MailboxTwoIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "299f0cc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('299f0cc2', __exports__)) {
    api.reload('299f0cc2', __exports__)
  }
  
  module.hot.accept("./MailboxTwoIcon.vue?vue&type=template&id=299f0cc2", () => {
    api.rerender('299f0cc2', render)
  })

}


export default __exports__